// extracted by mini-css-extract-plugin
export default {"container":"SandboxList_container__pyqOU","list":"SandboxList_list__saSHl"};